export default __webpack_public_path__ + "static/media/gasag_background_m2.bcb4a4b9.jpg";